import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResponseTranslation, TranslationLangKey } from '../models/translations';

@Injectable({ providedIn: 'root' })
export class LocaleHelperService {
  constructor(private translateService: TranslateService) {}

  translateWithFallback(key: string, fallback: string, params?: Record<string, unknown>): string {
    if (!key) return fallback;
    const translation = this.translateService.instant(key, params);
    return translation === key ? fallback : translation;
  }

  getLocalizedValue(value: ResponseTranslation | null | undefined): string {
    if (!value) return '';

    const lang =
      (this.translateService.currentLang as TranslationLangKey) || (this.translateService.getDefaultLang() as TranslationLangKey);

    return value[lang] || value.en || '';
  }
}
